import { AppRoutes } from "AppRoutes";
import { useBoard } from "providers";
import { useTranslations } from "providers";

export const BreadCrumbToggleBoardSettings: React.FC = () => {
  const i18n = useTranslations();

  const { board } = useBoard();
  if (!board || !board.canEdit) {
    return;
  }

  const isSettings = window.location.pathname.includes("settings");
  const url = isSettings ? AppRoutes.toBoard(board.id) : AppRoutes.toBoardSettings(board.id);
  const label = isSettings ? i18n.Actions_GoToRuns : i18n.Actions_GoToBoard;

  return (
    <div className="cta">
      <a className="d-block" id="breadcrumb-open-board-settings" href={url}>
        <span className="sbb-arrow-cta">{label}</span>
      </a>
    </div>
  );
};
